import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import themes from '../theme'
import PoseIcon from '@/components/icons/pose-icon'
import EstimatePoseIcon from '@/components/icons/estimate-pose-icon'
import PanCameraIcon from '@/components/icons/pan-camera-icon'
import FpsCameraIcon from '@/components/icons/fps-camera-icon'
import RotateCameraIcon from '@/components/icons/rotate-camera-icon'
import ZoomCameraIcon from '@/components/icons/zoom-camera-icon'
import ExitCameraIcon from '@/components/icons/exit-camera-icon'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes,
    options: {
      minifyTheme: css => Vue.appEnv.isDevelopment ? css : css.replace(/[\r\n|\r|\n]/g, ''),
      customProperties: true
    }
  },
  icons: {
    iconfont: 'mdiSvg',
    values: {
      poseCharacter: { component: PoseIcon },
      estimatePose: { component: EstimatePoseIcon },
      panCamera: { component: PanCameraIcon },
      fpsCamera: { component: FpsCameraIcon },
      rotateCamera: { component: RotateCameraIcon },
      zoomCamera: { component: ZoomCameraIcon },
      exitCamera: { component: ExitCameraIcon }
    }
  },
  breakpoint: {
    mobileBreakpoint: 'xs'
  }
})
